import Component from '../abstracts/Component';
import Cookies from 'js-cookie'

export default class NewsletterPopoverComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-newsletter.newsletter-popover',
      form: '.js-newsletter-form',
      close: '.js-close'
    };
  }

  get CLASSES() {
    return {
      animateCollapse: 'animate'
    };
  }


  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
  }


  bindEvents(el) {
    let ctx = this,
      $element = $(el),
      status = Cookies.get('nlPopoverShown'),
      registered = Cookies.get('nlRegistered'),
      attrs = $element.data();

    ctx.log('Binding newsletter popover');

    if (status != "true" && registered != "true") {
      setTimeout(() => {
        $element.css('visibility', 'visible');
        $element.addClass(ctx.CLASSES.animateCollapse);
        // for accessibility purpose, check if cookie layer is in page (first to get focus)
        if(document.querySelector('.js-cookie-layer') == null){
          $(document).on('keydown.popover', (e) => {
            e.preventDefault();
            if(e.keyCode != undefined){
              if (e.keyCode == 9 && !e.shiftKey) {
                this.log('newsletter - tabbed on page landing');
                const keyboard = document.querySelector('[data-whatinput="keyboard"]');
                const firstFocusable = this.$getFirstFocusable(el);
                if (keyboard) {
                  firstFocusable.focus();
                }
              }
              $(this).off(e);
            }
          });
        }
      }, attrs.timeToShow);

      $element.find(ctx.SELECTORS.close).on('click.newsletterPopover', function (e) {
        Cookies.set('nlPopoverShown', true, {
          expires: attrs.timeToExpires,
          secure: true
        })
        $element.removeClass(ctx.CLASSES.animateCollapse);
        setTimeout(() => {
          $element.remove();
        }, 1000);
      });
    }


  }

  render() {
    if (this.main.length) {
      this.main.each((index, element) => {
        this.bindEvents(element);
      })
    }
  }
}
